import {
    CREATE_YARN_PO_DETAILS_FAILURE_DK,
    CREATE_YARN_PO_DETAILS_REQUEST_DK,
    CREATE_YARN_PO_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_YARN_PO_DETAILS_DK,
    DELETE_YARN_PO_DETAILS_FAILURE_DK,
    DELETE_YARN_PO_DETAILS_REQUEST_DK,
    DELETE_YARN_PO_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_YARN_PO_DETAILS_FAILURE_DK,
    FETCH_SINGLE_YARN_PO_DETAILS_REQUEST_DK,
    FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS_DK,
    FETCH_YARN_PO_DETAILS_FAILURE_DK,
    FETCH_YARN_PO_DETAILS_REQUEST_DK,
    FETCH_YARN_PO_DETAILS_SUCCESS_DK,
    YARN_PO_DETAILS_USERFORM_RESET_DK,
    UPDATE_YARN_PO_DETAILS_FAILURE_DK,
    UPDATE_YARN_PO_DETAILS_REQUEST_DK,
    UPDATE_YARN_PO_DETAILS_SUCCESS_DK,
    FETCH_YARN_PO_DETAILS_BY_ID_REQUEST_DK,
    FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST_DK,
    FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS_DK,
    FETCH_YARN_PO_DETAILS_BY_ID_FAILURE_DK,
    FETCH_YARN_PO_PREVIOUS_LIST_REQUEST_DK,
    FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS_DK,
    FETCH_YARN_PO_PREVIOUS_LIST_FAILURE_DK,
    CLOSE_BTN_POST_REQUEST,
    CHECK_ALL_UPDATE_FALIURE,
    CLOSE_BTN_POST_FALIURE,
    CHECK_ALL_UPDATE_REQUEST
} from './yarnPODetails.actionsType';

export const YARN_PO_DK_DETAILS = 'yarnPODetailsDK';

let initialState = {
    loading: false,
    yarnPODetailsById: [],
    yarnPODetails: [],
    groupList: [],
    employeeList: [],
    RoleInTeamList: [],
    previousList: [],
    userform: {
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedTeamDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let yarnPODKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_PO_DETAILS_REQUEST_DK:
        case FETCH_YARN_PO_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_YARN_PO_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_YARN_PO_DETAILS_REQUEST_DK:
        case UPDATE_YARN_PO_DETAILS_REQUEST_DK:
        case DELETE_YARN_PO_DETAILS_REQUEST_DK:
        case FETCH_YARN_PO_DETAILS_GROUP_LIST_REQUEST_DK:
        case FETCH_YARN_PO_PREVIOUS_LIST_REQUEST_DK:
        case CLOSE_BTN_POST_REQUEST:
        case CHECK_ALL_UPDATE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPODetails: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_GROUP_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPODetailsById: updatePayload
            };

        case CREATE_YARN_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_YARN_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: updatePayload,
                userform: updatePayload
            };
        case UPDATE_YARN_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_YARN_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedTeamDetails: {}
            };
        case FETCH_YARN_PO_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_YARN_PO_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_YARN_PO_DETAILS_FAILURE_DK:
        case CREATE_YARN_PO_DETAILS_FAILURE_DK:
        case UPDATE_YARN_PO_DETAILS_FAILURE_DK:
        case DELETE_YARN_PO_DETAILS_FAILURE_DK:
        case FETCH_YARN_PO_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_YARN_PO_PREVIOUS_LIST_FAILURE_DK:
        case CLOSE_BTN_POST_FALIURE:
        case CHECK_ALL_UPDATE_FALIURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_PO_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case YARN_PO_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        default:
            return state;
    }
};
